import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import { AuthService } from '../app/api/';
import { Router } from '@angular/router';
import { Injectable} from '@angular/core';

@Injectable()
export class AuthenticationGuard implements CanActivate {

    constructor(private authService: AuthService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let url = route.url[0];
        if (!this.authService.isUserLoggedIn()) {
            
            this.router.navigate(['login',{redirect: url}]);
        }
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/directives/authentication.guard.ts